import { render, staticRenderFns } from "./auditLogs.vue?vue&type=template&id=93d6cfd6&"
import script from "./auditLogs.vue?vue&type=script&lang=js&"
export * from "./auditLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports